import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';

import { StorageService } from '@core/services/util/storage.service';
import { GtmService } from '@app/core/services/analytics/gtm.service';

import { environment } from '@environment';
import { DeviceService } from '@app/core/services/util/device.service';
import { FormsModule } from '@angular/forms';
import { NgForm } from '@angular/forms';

type Outlet = {
    oa: boolean; //offer_availability -> for showing offer icon
    outlet_id: number;
    outlet_name: string;
    type_label: string;
    type_desc: string;
    serviceable: boolean;
    agent_id: string | null;
    service_type: string;
};

@Component({
    selector: 'app-outlet-selection',
    templateUrl: './outlet-selection.component.html',
    styleUrls: ['./outlet-selection.component.scss'],
    standalone: true,
    imports: [FormsModule, MatDialogModule]
})
export class OutletSelectionComponent implements OnInit {
    isMobile: boolean;
    DEPLOY_URL: string;
    loggedIn = false;

    currentOutlet: Outlet;
    outsideOutlet: Outlet;
    nearbyOutlets: Outlet[] = [];
    @ViewChild('addressSelectionForm') addressSelectionForm: NgForm;

    constructor(
        private gtmService: GtmService,
        private deviceService: DeviceService,
        private storageService: StorageService,
        private dialogRef: MatDialogRef<OutletSelectionComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        this.loggedIn = this.isLoggedIn();
        this.DEPLOY_URL = environment.DEPLOY_URL;
        this.isMobile = this.deviceService.isMobile();
    }

    ngOnInit(): void {
        const { outlet, nearby, outside_link } = this.data.outlet;

        this.outsideOutlet = outside_link;

        const { active, open, id, name, type_label, type_desc, agent_id, service_type, oa } = outlet;
        this.currentOutlet = {
            oa,
            agent_id,
            type_label,
            type_desc,
            service_type,
            outlet_id: id,
            outlet_name: name,
            serviceable: active && open
        };

        this.nearbyOutlets.push(this.currentOutlet);

        nearby.forEach((outlet: Outlet) => {
            this.nearbyOutlets.push(outlet);
        });

        this.gtmService.logEvent('web_analytics', {
            event_action: 'new_ordering_flow',
            event_label: 'Outlet Selection Screen',
            value1: 'Opened'
        });
    }

    isLoggedIn(): boolean {
        return this.storageService.get('session-id') && this.storageService.get('phone_no');
    }

    onConfirm() {
        // Submit the form
        const { selected_outlet } = this.addressSelectionForm.value;
        if (!selected_outlet) {
            this.gtmService.logWebAnalyticsEvent('new_ordering_flow', 'No Outlet is selected');
        } else {
            const { outlet_id, agent_id, service_type, fetch } = selected_outlet;
            this.dialogRef.close({
                agent_id,
                outlet_id,
                service_type,
                type: fetch ? 'other-outlet' : 'current-outlet'
            });
        }
    }

    outsideLocation() {
        this.gtmService.logWebAnalyticsEvent('new_ordering_flow', 'Outside Location Selected');
        const { outlet_id, agent_id, service_type } = this.outsideOutlet;
        this.dialogRef.close({
            agent_id,
            outlet_id,
            service_type,
            type: 'other-outlet'
        });
    }
}
